var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rfbglr123a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.458824 0 0 0 0 0.482353 0 0 0 0 0.513725 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-925 -28)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.882 12.881c.038-.281.057-.572.057-.881 0-.3-.019-.6-.067-.881l1.956-1.482c.174-.13.222-.384.116-.571l-1.85-3.113c-.116-.206-.357-.272-.569-.206l-2.304.9c-.481-.356-.992-.656-1.56-.881l-.348-2.382C14.275 3.16 14.082 3 13.851 3h-3.702c-.23 0-.414.16-.452.384L9.35 5.766c-.57.225-1.09.534-1.562.88l-2.303-.9c-.212-.074-.453 0-.569.207l-1.84 3.113c-.116.196-.078.44.115.571l1.956 1.482c-.048.281-.086.59-.086.881 0 .29.019.6.067.881l-1.956 1.482c-.174.13-.222.384-.116.571l1.85 3.113c.116.206.357.272.569.206l2.304-.9c.481.356.992.656 1.56.881l.348 2.382c.048.225.231.384.462.384h3.702c.23 0 .424-.16.452-.384l.347-2.382c.57-.225 1.09-.525 1.562-.88l2.303.9c.212.074.453 0 .569-.207l1.85-3.113c.116-.206.068-.44-.115-.571l-1.937-1.482zM12 16c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z",
    transform: "translate(925 28)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSettings);
export default __webpack_public_path__ + "static/media/icons-settings.c2b84d2e94591731e3db569576d54107.svg";
export { ForwardRef as ReactComponent };